import {
  Avatar,
  Box,
  Button,
  Card,
  Hidden,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import NoDataToBeShown from "../reusable/NoDataToBeShown";
import { Application, Application4Table } from "./apps-types";
import checkPlatform from "../../utils/checkPlatform";
import { formatDistance } from "date-fns";
import { enUS, it } from "date-fns/locale";
import reportWebVitals from "../../reportWebVitals";
import { Apple, Android, Delete } from "@mui/icons-material";

function AppCardSkeleton() {
  return (
    <Card>
      <Stack direction="row" spacing={3}>
        <Box padding={"3%"}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Skeleton variant="rectangular" width={60} height={60} />
            <Skeleton variant="rectangular" width={210} height={30} />

            <Box sx={{ alignItems: "right" }}>
              <Hidden smDown>
                <Skeleton variant="rectangular" width={210} height={30} />
              </Hidden>
            </Box>
            <Box>
              <Hidden smDown>
                <Skeleton variant="rectangular" width={60} height={30} />
              </Hidden>
            </Box>
          </Stack>
        </Box>
      </Stack>
    </Card>
  );
}

function AppCard(props: {
  open: boolean;
  setOpen: any;
  app: Application;
  apps: Application[];
  deletedApp?: Application | Application4Table;
  setDeletedApp: any;
}) {
  const handleSetDeleteInfo = (element: Application) => {
    props.setOpen(true);
    props.setDeletedApp(element);
  };

  return (
    <div>
      {props.app && (
        <Card sx={{ boxShadow: 3, borderRadius: 1.5 }}>
          <Box padding={"3%"}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <NavLink
                to={"/applications/" + props.app.name}
                state={{ id: props.app.id, appName: props.app.name }}
                style={{ textDecoration: "none" }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Avatar
                    alt={props.app.name}
                    src={`${process.env.REACT_APP_BACKEND_BASE_URL}apps/${props.app.id}/icon`}
                    sx={{ width: 60, height: 60, borderRadius: 1.5 }}
                  />
                  <Box>
                    <Stack direction="row" spacing={1}>
                      <Typography
                        variant="h5"
                        sx={{ color: "text.primary", textDecoration: "none" }}
                        noWrap
                      >
                        {props.app.name}
                      </Typography>
                      <Stack direction="row">
                        {(checkPlatform(props.app.versions) ===
                          "Android; iOS;" ||
                          checkPlatform(props.app.versions) === "iOS") && (
                          <Apple
                            color="action"
                            sx={{ width: 22, height: 22 }}
                          />
                        )}
                        {(checkPlatform(props.app.versions) ===
                          "Android; iOS;" ||
                          checkPlatform(props.app.versions) === "Android") && (
                          <Android
                            color="action"
                            sx={{ width: 22, height: 22 }}
                          />
                        )}
                      </Stack>
                    </Stack>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                      noWrap
                    >
                      {props.app.description}
                    </Typography>
                  </Box>
                </Stack>
              </NavLink>
              <Hidden smDown>
                <Box sx={{ alignItems: "right" }}>
                  <Typography
                    variant="caption"
                    sx={{ pr: 3, color: "text.secondary", textAlign: "right" }}
                  >
                    {formatDistance(
                      new Date(props.app.updated_at),
                      new Date(),
                      {
                        locale:
                          localStorage.getItem("lng") === "it" ? it : enUS,
                      }
                    )}
                  </Typography>
                </Box>
              </Hidden>
              <Hidden smDown>
                <Box>
                  <Button onClick={() => handleSetDeleteInfo(props.app)}>
                    <Delete color="action" />
                  </Button>
                </Box>
              </Hidden>
            </Stack>
          </Box>
        </Card>
      )}
    </div>
  );
}

function AppsCard(props: {
  open: boolean;
  setOpen: any;
  reverseData: Application[];
  isLoading: boolean;
  deletedApp?: Application | Application4Table;
  setDeletedApp: any;
}) {
  const skeletonArray = Array(6).fill("");

  return props.isLoading ? (
    <Stack spacing={3} sx={{ p: 3, pr: 0 }}>
      {skeletonArray.map((skeleton, index) => (
        <AppCardSkeleton key={index} />
      ))}
    </Stack>
  ) : props.reverseData.length > 0 ? (
    <Stack spacing={3} sx={{ pt: "5%" }}>
      {props.reverseData.map((app) => (
        <AppCard
          key={app.name}
          open={props.open}
          setOpen={props.setOpen}
          app={app}
          apps={props.reverseData}
          deletedApp={props.deletedApp}
          setDeletedApp={props.setDeletedApp}
        />
      ))}
    </Stack>
  ) : (
    <NoDataToBeShown />
  );
}

export default AppsCard;

reportWebVitals();
